module.exports = __webpack_public_path__ + "static/media/icon_service_05_pc.85d68ead.webp";